import React from 'react';
import { css } from 'styled-components';
import PersonInfo from 'components/common/PersonInfo';
import { toLocalString } from 'util/filters';
import i18n from 'i18n';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import SubHeading from 'components/common/SubHeading';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';

const formatPurchaseItemName = purchaseItems =>
  purchaseItems[0].name +
  ' ' +
  toLocalString(purchaseItems[0].price) +
  i18n.t('common:yen');

const Order = ({
  className,
  name,
  telephone,
  email,
  purchaseItems,
  deliveryItem,
  totalVoucherPrice,
  totalDeliveryPrice,
  billingAmount,
  mean,
  nameKana,
  paymentStatus
}) => (
  <section className={className}>
    <div className="order">
      <div className="orderer">
        <SubHeading>{i18n.t('mypage:ordererInfo')}</SubHeading>
        <PersonInfo
          name={name}
          tel={telephone}
          email={email}
          nameKana={nameKana}
        />
      </div>

      <div className="order-info">
        <SubHeading>{i18n.t('mypage:orderDetail')}</SubHeading>
        <p>{formatPurchaseItemName(purchaseItems)}</p>
        <ul className="total-number">
          <li className="total-voucher-price">
            <div className=" total-voucher-price-label">
            <span className="content-label">
              {i18n.t('mypage:totalVoucherPrice')}
            </span>
            <span> : </span>
            </div>
            <span>
              {totalVoucherPrice &&
                `${toLocalString(totalVoucherPrice)}${i18n.t(
                  'common:yen'
                )}(${toLocalString(purchaseItems[0].price) +
                  i18n.t('common:yen')} × ${purchaseItems[0].num})`}
            </span>
          </li>
          <li>
            <span className="content-label">
              {i18n.t('mypage:totalDeliveryPrice')}
            </span>
            <span> : </span>
            <span>
              {totalDeliveryPrice &&
                `${toLocalString(totalDeliveryPrice)}${i18n.t(
                  'common:yen'
                )}(${toLocalString(deliveryItem.price) +
                  i18n.t('common:yen')} × ${deliveryItem.num})`}
            </span>
          </li>
        </ul>
        <ul className="billing-amount">
          <li>
            <span className="content-label">{i18n.t('mypage:bill')}</span>
            <span> : </span>
            <span>
              {billingAmount &&
                `${toLocalString(billingAmount)}${i18n.t('common:yen')}`}
            </span>
          </li>
          <li className="payment-type">
            <div className="payment-type-label">
              <span className="content-label">
                {i18n.t('mypage:paymentType')}
              </span>
              <span> : </span>
            </div>
            <div>
              <span>
                {mean} / {paymentStatus}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
);

const commonStyle = css`
  .order-info {
    > p {
      padding-bottom: 12px;
      margin: 0 0 12px 0;
      border-bottom: 1px solid ${Colors.gray2};
    }

    ul {
      list-style: none;
      padding: 0 0 12px;
      margin: 0 0 12px 0;

      &:last-child {
        padding-bottom: 0;
        margin-bottom: 0;
      }

      li:first-child {
        margin-bottom: 2px;
      }

      .payment-type, .total-voucher-price {
        display: flex;

        div {
          &.payment-type-label {
            min-width: 108px;
          }

          &.total-voucher-price-label {
            min-width: 110px;
          }
        }
      }
    }

    .total-number {
      border-bottom: 1px dotted ${Colors.gray2};
    }

    .content-label {
      display: inline-block;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  display: flex;

  .order {
    width: 100%;

    .orderer {
      margin-bottom: 40px;
    }
  }

  .order-info {
    position: relative;
    margin-right: 32px;

    .total-number,
    .billing-amount {
      .content-label {
        ${FontStyles.text8};
        width: 96px;
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  ${SubHeading} {
    margin-bottom: 12px;
    ${FontStyles.text5};
  }

  .order {
    .orderer {
      margin-bottom: 24px;
    }

    .order-info {
      .total-number,
      .billing-amount {
        .content-label {
          ${FontStyles.text6};
          width: 96px;
        }
      }
    }
  }
`;

export default applyStyles(Order)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Mypage/History/components/Order.js